//初期状態
const form = {
  login: {},
  layout: {
    backgroundColor: '#FFFFFF',
    title: '',
  },
  showLogoutModal: false,
  global: {
    fontSize: '14px',
    newSearchMode: null,
    receiptLabel: undefined,
    suggestTerm: 7, //自動再出題の期間
    explanationDisplayAlways: '0', //○×問題の解説表示設定
    tag: {
      warning: '数値',
      danger: '用語',
      primary: '単位',
      info: '公式',
      success: 'その他',
      black: '黒',
      white: '白',
    },
    loginNameDisplay: true,
    note: '',
    dbVersion: undefined,
    lastFetchTime: '2018-02-13 10:25',

    updateDate: undefined,
    markerMode: '0',
    //出題範囲
    searchMode: '3',
    //search display
    displayType: '0',
    displayOption: '0',
    displaySort: '0',
    scrollTo: undefined,
    currentDisplay: '0',
    searchHistory: [],
  },
  search: {
    division1: 1,
    division2: [],
    question: [],
    resolveQuestion: [],
    questionIndex: undefined,
    resolveQuestionIndex: undefined,
    keyword: '',
    goback: false,
    answerCount: undefined,
    focusSearch: false,
    foucsSheetList: [],
  },
  prediction: {
    selectedIndex: undefined,
    searchMode: '2',
    updateDate: undefined,
  },
  isWhileUpdate: false,
};

export default form;



// WEBPACK FOOTER //
// ./src/reducers/form.js